import { isEmpty } from 'lodash'

export function spendingReducer(state = {
    ALL: {},
    WaitingPayment: {},
    Payed: {},
},{
    type,
    payload
}){
    switch(type){
        case "GET_SPENDINGS":
            let list = Object.assign({}, state)
            list.ALL = isEmpty(list.ALL) ? payload : Object.assign(list.ALL, payload)
            Object.values(payload).forEach( spending => {
                list[spending.actionStatus][spending.timeAction] = spending
            })
            return list;
        
        // case "UPDATE_SPENDING":
        //     list = Object.assign({}, state)
        //     list.ALL[payload.ID].actionStatus = payload.newStatus
        //     Object.values(payload).forEach( spending => {
        //         list[spending.actionStatus][spending.timeAction] = spending
        //     })
        //     return list;
        
        default:
            return state;
    }
}